<template>
    <base-layout
        page-default-back-link="/login"
        showUserSettings="true"
        showSettings="true"
    >

        <div class="error ion-text-center pdt-20">{{error}}</div>
        <div class="message ion-text-center">{{message}}</div>

        <ion-grid>
            <ion-row>
                <ion-col class="ion-text-center">
                    <ion-button size="large" @click="start_scan">
                        <ion-icon slot="icon-only" :icon="qrCodeOutline"></ion-icon>
                        <p>&nbsp;Scan QR / Barcode</p>
                    </ion-button>
<!--                     <br>
                    <ion-button size="large" @click="start_scan_with_html5">
                        <ion-icon slot="icon-only" :icon="qrCodeOutline"></ion-icon>
                        <p>&nbsp;Scan QR Code with html 5</p>
                    </ion-button> -->
                </ion-col>
            </ion-row>
        </ion-grid>


    </base-layout>
</template>

<script>

import { IonGrid, IonRow, IonCol, IonButton, IonIcon, modalController } from '@ionic/vue';
import ScanQRcode from '../components/ScanQRcode.vue';
import ScanQRcodeHTML5 from '../components/ScanQRcodeHTML5.vue';
import { qrCodeOutline } from "ionicons/icons";

export default {
    components: {
        IonGrid,
        IonRow,
        IonCol,
        IonButton,
        IonIcon
    },

    data(){
        return {
            error:'',
            message:'',

            qrCodeOutline
        }
    },

    methods:{

        async start_scan(){

            const modal = await modalController.create({
                component: ScanQRcode,
                cssClass: 'custModal',
                componentProps: {
                    title: 'Scan Product/Inventory'
                },
            });

            var currentComponent = this;
            modal.onDidDismiss().then((modelData) => {
                if (modelData !== null) {
                    this.modelData = modelData.data;
                    if(modelData.data!='cancelled')
                        currentComponent.search_scanned_product(modelData.data)
                    this.error = '';
                    this.message = 'You can scan another item by clicking below...';
                }
            });
            return modal.present();

        },

        async start_scan_with_html5(){

            const modal = await modalController.create({
                component: ScanQRcodeHTML5,
                cssClass: 'custModal',
                componentProps: {
                    title: 'Scan Product/Inventory'
                },
            });

            var currentComponent = this;
            modal.onDidDismiss().then((modelData) => {
                if (modelData !== null) {
                    this.modelData = modelData.data;
                    if(modelData.data!='cancelled')
                        currentComponent.search_scanned_product(modelData.data)
                    this.error = '';
                    this.message = 'You can scan another item by clicking below...';
                }
            });
            return modal.present();

        },

        async search_scanned_product(scanned_code){

            console.log("Scanned code is: "+scanned_code);

            await this.$store.dispatch('visits/item_scan', { code: scanned_code });
            var request_error = this.$store.getters['visits/getRequestError'];
            console.log('Error: '+request_error);

            if( request_error != ''){
                this.error = request_error;
                this.message = '';
            } else {
                console.log('Scanned complete');

                var scanResult = this.$store.getters['visits/getItemFromScan'];
                console.log(scanResult);
                if (scanResult.inventory==false) {
                    this.selected_item = scanResult.product;
                    this.$router.push({ name:'Products', params:{ pitem_id:this.selected_item.pitem_id, master_conn_id:this.selected_item.master_conn_id }})
                } else {
                    this.selected_item = scanResult.inventory;
                    this.$router.push({ name:'Inventory', params:{ inv_id:this.selected_item.inv_id, master_conn_id:this.selected_item.master_conn_id }})
                }
            }

        }

    },

    ionViewDidEnter(){
        const { open_scan } = this.$route.params;

        if(open_scan==1){
            this.start_scan();
            //this.start_scan_with_html5();
        } else {
            this.error = '';
            this.message = 'You can scan another item by clicking below...';
        }
    }

}
</script>

<style scoped>
    .error {
      color: red;
      font-size: 15px;
      margin:20px;
    }

    .message {
      color: green;
      font-size: 15px;
      margin:20px;
    }

    ion-button {
        color: #404040;
        --background: #ffffff;
    }

    ion-grid {
        margin:50px;
    }
</style>